import { call, put } from 'redux-saga/effects';

import { removeTokens } from 'api/utils/tokenManagement';
import BrowserStorage from 'api/utils/browserStorage';

import { resetUserData } from 'store/user/actions';
import { resetSubscriptions } from 'store/subscriptions/actions';

import { setAuthenticationStatus } from '../actions';
import { closeChatbotSaga } from 'store/user/sagas/openSupportFormSaga';

export function* logoutSaga() {
    yield call(closeChatbotSaga);
    yield call(removeTokens);
    yield call(BrowserStorage.clearExcept, ['language']);

    yield put(setAuthenticationStatus(false));
    yield put(resetUserData());
    yield put(resetSubscriptions());
}
